enum ApprovalStatus {
  IN_PROGRESS = "IN_PROGRESS",
  APPROVED = "APPROVED",
  READY_TO_APPROVE = "READY_FOR_APPROVE",
  RELEASED = "RELEASED",
}

export default ApprovalStatus;
